import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import { useRef, useState } from "react";
import { Box, Divider } from "@mui/material";

type Option = {
  label: string;
  onClick: () => void;
};

type Props = {
  renderButton: (props: {
    onClick: (e: React.MouseEvent) => void; // i understand now
    ref: React.Ref<HTMLButtonElement> | null;
    isOpen: boolean;
  }) => React.ReactNode;
  options: Option[];
  zIndex?: number;
  disableCloseOnClick?: boolean;
  dividers?: boolean;
};

const ButtonWithOptionsMenu = ({
  renderButton,
  options,
  zIndex,
  disableCloseOnClick,
  dividers,
}: Props) => {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef<HTMLButtonElement | null>(null);

  const handleToggle = () => setOpen((prev) => !prev);

  const handleClose = (event: Event) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }

    setOpen(false);
  };

  const handleMenuClick = (e: React.MouseEvent, onClick: () => void) => {
    onClick();
    if (!disableCloseOnClick) handleClose(e.nativeEvent);
  };

  return (
    <>
      {renderButton({
        onClick: handleToggle,
        ref: anchorRef,
        isOpen: open,
      })}
      <Popper
        sx={{
          zIndex: zIndex || 1,
        }}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        placement="bottom-end"
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom-end" ? "center top" : "center bottom",
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu" autoFocusItem>
                  {options.map(({ label, onClick }, index) => (
                    <Box key={label}>
                      <MenuItem onClick={(e) => handleMenuClick(e, onClick)}>
                        {label}
                      </MenuItem>
                      {dividers && index !== options.length - 1 && <Divider />}
                    </Box>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
};

export default ButtonWithOptionsMenu;
